import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

// API endpoint for current week schedule
const SCHEDULE_API = 'https://api.threes.day/player/league/b8629e8f-9700-435f-b2f7-e804f2d5a05a/schedule/week/current';

// Calculate season week dynamically based on May 1 2025 = week 3
function getCurrentWeekNumber(now = new Date()) {
  const base = new Date(2025, 4, 1);
  const msPerWeek = 7 * 24 * 60 * 60 * 1000;
  const delta = now.getTime() - base.getTime();
  const weeksSince = delta >= 0 ? Math.floor(delta / msPerWeek) : 0;
  return 3 + weeksSince;
}

const MatchupsApp = () => {
  const [emailFilter, setEmailFilter] = useState('');
  const [schedule, setSchedule] = useState([]);
  const thisWeek = getCurrentWeekNumber();

  // Fetch the current week schedule from API
  useEffect(() => {
    fetch(SCHEDULE_API)
      .then(res => res.json())
      .then(data => setSchedule(data))
      .catch(console.error);
  }, []);

  // Filter matchups by email
  const filteredMatchups = schedule
    .filter(game => game.week == thisWeek)
    .flatMap(game =>
      game.matches.map((pair, idx) => {
        const left = pair[0];
        const right = pair[1];
        const match = { title: game.title, rank: left.rank, left, right };
        if (!emailFilter) return match;
        const email = emailFilter.toLowerCase();
        return (
          left.formattedEmail.toLowerCase().includes(email) ||
          right.formattedEmail.toLowerCase().includes(email)
        ) ? match : null;
      })
    )
    .filter(Boolean);

  if (!schedule.length) {
    return <p>Loading schedule...</p>;
  }

  return (
    <div className="container my-4">
      <h1 className="mb-4">Week {thisWeek} Matchups</h1>

      <div className="mb-3">
        <label htmlFor="emailFilter" className="form-label">
          Filter by Player Email:
        </label>
        <input
          type="text"
          id="emailFilter"
          className="form-control"
          placeholder="Enter email to filter..."
          value={emailFilter}
          onChange={e => setEmailFilter(e.target.value)}
        />
      </div>

      {filteredMatchups.length === 0 && <p>No matchups found.</p>}

      {filteredMatchups.map((m, i) => (
        <div className="card mb-3" key={i}>
          <div className="card-header bg-dark text-white">
            {m.title} — Rank {m.rank}
          </div>
          <div className="card-body p-0">
            <table className="table mb-0">
              <thead>
                <tr>
                  <th>Player A</th>
                  <th>Player B</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>{m.left.formattedName}</strong><br/>
                    Email: <a href={`mailto:${m.left.email}`}>{m.left.formattedEmail}</a><br/>
                    Quota: {m.left.calculatedQuota}
                  </td>
                  <td>
                    <strong>{m.right.formattedName}</strong><br/>
                    Email: <a href={`mailto:${m.right.email}`}>{m.right.formattedEmail}</a><br/>
                    Quota: {m.right.calculatedQuota}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MatchupsApp;